import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import configStore from "./Store/configStore";
import {Provider} from 'react-redux';
import './dark.scss';
import {BrowserRouter} from "react-router-dom";
import DesktopNotification from "./Components/DesktopNotification/DesktopNotification";

ReactDOM.render(
    <React.StrictMode>
        <Provider store={configStore}>
            <BrowserRouter>
                <DesktopNotification/>
                <App/>
            </BrowserRouter>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
